import * as React from "react";
import {PrimaryLayout} from "components/widgets/PrimaryLayout";
import {SecondaryBar} from "components/widgets/SecondaryBar";
import {UIState} from "data/UIState";

import './AccountPageWrapper.pcss';

interface Props {
  title:string;
  subTitle?:string;
  backOrCloseAction:()=>void;
  backOrCloseLabel:string;
  children:React.ReactNode;
}

export const AccountPageWrapper = (props:Props) => {
  return (
    <PrimaryLayout className={"profile"}>
      <SecondaryBar
        title={props.title}
        subTitle={props.subTitle ? props.subTitle : ""}
        buttonAction={props.backOrCloseAction}
        buttonLabel={props.backOrCloseLabel}
      >
      </SecondaryBar>

      <div style={{height: '30px'}}></div>

      {props.children}

    </PrimaryLayout>

  );
}
